import { ReactNode, useContext } from "react";
import { useTranslation } from "react-i18next";

import { MissingFieldsContext, normalizeFieldPath } from "../MissingFieldsContext";

export function useMissingFieldMessage(path: string, label: ReactNode): string | undefined {
  const { t } = useTranslation();
  const messages = useContext(MissingFieldsContext);
  const normalizedPath = normalizeFieldPath(path);

  if (!messages.has(normalizedPath)) {
    return undefined;
  }

  return (
    messages.get(normalizedPath) ??
    (typeof label === "string" && label
      ? t("common.validation.fieldRequired", { fieldName: label })
      : t("common.validation.required"))
  );
}
